import axios from 'axios'

let creditFetchPromise = null
let creditFetchedAt = 0
const CREDIT_TTL_MS = 15000

export const user = {
  namespaced: true,
  state: {
    user: null,
    userCredit: 0
  },
  getters: {
    isLogged: state => !!state.user,
    currentUser: state => {
      // was throwing errors on login, register and index page
      if (state.user) {
        const fullNameObj = {
          fullName: `${state.user.firstName} ${state.user.lastName}`
        }
        return { ...state.user, ...fullNameObj }
      } else return {}
    },
    userCredit (state) { // stravnik UI
      return state.userCredit
    }
  },
  mutations: {
    setUserData (state, userData) {
      state.user = userData
      localStorage.setItem('user', JSON.stringify(userData))
      localStorage.removeItem('shoppingCart')
      axios.defaults.headers.common.Authorization = `Bearer ${userData.accessToken}`
    },
    clearUserData (state) {
      state.user = null
      delete axios.defaults.headers.common.Authorization
      localStorage.removeItem('user')
      localStorage.removeItem('shoppingCart')
      creditFetchPromise = null
      creditFetchedAt = 0
    },
    // stravnik
    storeCredit (state, credit) {
      state.userCredit = credit
    },
    updateCredit (state, credit) {
      if (!state.user) return
      state.user.credit = credit
      localStorage.setItem('user', JSON.stringify(state.user))
    }
  },
  actions: {
    /**
     * Deduped credit refresh shared by appbar/navbar/order pages.
     * @param {{ force?: boolean }} payload
     */
    fetchCredit ({ commit, state }, payload = {}) {
      const force = !!(payload && payload.force)
      const now = Date.now()

      if (!force && creditFetchedAt && (now - creditFetchedAt) < CREDIT_TTL_MS) {
        return Promise.resolve(state.user ? state.user.credit : null)
      }

      if (creditFetchPromise) {
        return creditFetchPromise
      }

      creditFetchPromise = axios.get('/users/me/credit')
        .then(response => {
          const credit = response.data.credit
          commit('updateCredit', credit)
          creditFetchedAt = Date.now()
          return credit
        })
        .catch(() => null)
        .finally(() => {
          creditFetchPromise = null
        })

      return creditFetchPromise
    }
  }
}
